
import { Button } from "@/components/ui/button";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels } from "@/i18n";

export const TimelineHeader = () => {
  const uiLabels = vehicleCardUILabels(getLanguage());
  
  return (
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold text-card-foreground">{uiLabels.eventHistory}</h3>
    </div>
  );
};
